import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/global-options*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const globalOptionsRoute = defineRoute("/libraries/global-options");
export const globalOptionRoute = defineRoute("/libraries/global-options/:idOrAdd");
export const globalOptionsLegacyRoute = defineRoute("/libraries/global-options-legacy");
